// const alarmList = () =>
//   import("@/views/alarm-manage/alarm-list/alarm-list.vue");
// const alarmDetail = () =>
//   import("@/views/alarm-manage/alarm-list/children/pi-alarm-detail.vue");
// const alarmOverView = () =>
//   import("@/views/alarm-manage/alarm-overview/alarm-overview.vue");
const alarmEvent = () => import("@/views/alarm-manage/alarm-event/alarm-event.vue");
//
const routerList = [
    // {
    //   path: "/alarm-list",
    //   name: "告警管理",
    //   component: alarmList
    // },
    // {
    //   path: "/alarm-list/detail",
    //   name: "告警管理详情",
    //   component: alarmDetail
    // },
    // {
    //   path: "/alarm-overview",
    //   name: "告警概览",
    //   component: alarmOverView
    // },
    {
        path: "/alarm-event",
        name: "告警概览",
        component: alarmEvent,
    },
];
export default routerList;
